// Generated by Melange

import * as Buhta_cabinet__Btn from "../../../html/Btn.js";
import * as Buhta_cabinet__NewItemDropdown from "./NewItemDropdown.js";
import * as Buhta_cabinet__Panel from "../../../html/Panel.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GlobalStateContext from "../../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(org) {
  return function (onItemBeingAdded) {
    const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
    const deviceType = state.deviceType;
    const match = React.useState(function () {
          return false;
        });
    const setShowDropdown = match[1];
    const showDropdown = match[0];
    return JsxRuntime.jsx(Buhta_cabinet__Panel.make, {
                title: "Режим продаж",
                textSize: deviceType === "mobile" ? "s" : "l",
                rightActions: {
                  hd: deviceType === "mobile" ? JsxRuntime.jsx(Buhta_cabinet__NewItemDropdown.Mobile.make, {
                          onItemBeingAdded: onItemBeingAdded,
                          showDropdown: showDropdown,
                          setShowDropdown: setShowDropdown
                        }) : JsxRuntime.jsx(Buhta_cabinet__NewItemDropdown.Desktop.make, {
                          onItemBeingAdded: onItemBeingAdded,
                          showDropdown: showDropdown,
                          setShowDropdown: setShowDropdown
                        }),
                  tl: /* [] */0
                },
                shadowed: true,
                rounded: true,
                className: "mt-4 lg:mt-0",
                children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("img", {
                              className: "h-30",
                              src: StaticAsset.src("/static/images/new-kassa.png"),
                              width: "130px"
                            }),
                        deviceType === "mobile" ? JsxRuntime.jsx(Buhta_components__Text.H3.make, {
                                className: "mt-6 w-full text-center text-gray-medium",
                                children: "Для начала продаж добавьте товары и услуги"
                              }) : JsxRuntime.jsx(Buhta_components__Text.H1.make, {
                                className: "mt-10 w-106 text-center",
                                children: "Для начала продаж добавьте товары и услуги"
                              }),
                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              className: "mt-4 text-center text-gray-medium",
                              children: "Список можно пополнять с помощью кнопки \"+\""
                            }),
                        JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
                              title: "Добавить товар или услугу",
                              onClick: (function (param) {
                                  Curry._1(setShowDropdown, (function (param) {
                                          return true;
                                        }));
                                }),
                              className: "px-6 mt-6 py-3",
                              text: deviceType === "mobile" ? /* He5 */1 : /* He4 */0
                            })
                      ],
                      className: "flex flex-col items-center px-6 lg:px-0 py-10 lg:py-30"
                    })
              });
  };
}

function CashboxCatalog(Props) {
  return make(Props.org)(Props.onItemBeingAdded);
}

const make$1 = CashboxCatalog;

export {
  make$1 as make,
}
/* Buhta_cabinet__Btn Not a pure module */
